import React from 'react';
const ResumeForm = () => {
  return <button className="text-sm text-slate-200 hover:text-white transition-colors" data-id="element-216" data-mp="3269pxvln7gn0">
      Save & Resume Later
    </button>;
};
export default ResumeForm;